import { buildApiUrl } from '../config/api';

const NODE_CONFIG_PATHS = [
  '/ai-studio/v1/api/nodes',
  '/ai-studio/v1/nodes',
];

export const normalizeNodeConfigs = (payload) => {
  const rawConfigs = payload?.nodes && typeof payload.nodes === 'object'
    ? payload.nodes
    : payload;

  return Object.fromEntries(
    Object.entries(rawConfigs || {}).filter(([, config]) => (
      config &&
      typeof config === 'object' &&
      typeof config.name === 'string'
    ))
  );
};

export const fetchNodeConfigsWithFallback = async () => {
  const failures = [];

  for (const path of NODE_CONFIG_PATHS) {
    try {
      const response = await fetch(buildApiUrl(path), {
        method: 'GET',
        credentials: 'include',
      });

      const result = await response.json();

      if (!response.ok) {
        const errorMessage = result?.error || `HTTP ${response.status}`;
        failures.push(`${path}: ${errorMessage}`);
        continue;
      }

      const normalized = normalizeNodeConfigs(result);
      if (Object.keys(normalized).length === 0) {
        failures.push(`${path}: empty node definitions`);
        continue;
      }

      return { configs: normalized, sourcePath: path };
    } catch (error) {
      failures.push(`${path}: ${error.message}`);
    }
  }

  const detail = failures.join(' | ');
  throw new Error(`ノード設定の取得に失敗しました (${detail})`);
};
